import React, { useEffect, useState } from 'react';

import { NoteModal } from '.';
import { addNoteModalStateChange } from './../store/actions';
import { useDispatch } from 'react-redux';
import { NotesRequestBase } from '../../../shared/models';

export type CreateNoteFromFileModalProps = {
  fileId: string;
  baseRequestParams: NotesRequestBase;
  isMomentumEnabled: boolean;
};

const CreateNoteFromFileModal: React.FC<CreateNoteFromFileModalProps> = ({
  fileId,
  baseRequestParams,
  isMomentumEnabled
}) => {
  const [modalVisible, setModalVisible] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setModalVisible(true);
  }, [fileId, baseRequestParams, isMomentumEnabled]);

  const handleCloseModal = (): void => {
    dispatch(addNoteModalStateChange(false) as any);
    setTimeout(() => setModalVisible(false));
  };

  return (
    <NoteModal
      visible={modalVisible}
      close={() => handleCloseModal()}
      baseRequestParams={baseRequestParams}
      fileId={fileId}
      isMomentumEnabled={isMomentumEnabled}
    />
  );
};

export default CreateNoteFromFileModal;
